import type { IExerciseRecord, ITrainingRecord } from "@/hooks/useAppState";

/** Session completion is separate from performed volume: skipped sets stay unperformed. */
export function isTrainingRecordComplete(
  record: Pick<ITrainingRecord, "sessionStatus" | "completedSets" | "totalSets" | "exercises">,
): boolean {
  if (record.sessionStatus) return record.sessionStatus === "completed";
  if (record.totalSets > 0 && record.completedSets >= record.totalSets) return true;
  // Older finished sessions have no status; their skipped actions still resolve the session.
  return record.completedSets > 0 && record.exercises.length > 0 && record.exercises.every(
    exercise => exercise.skipped || (exercise.sets.length > 0 && exercise.sets.every(set => set.completed)),
  );
}

export function completeWorkoutSet(
  exercises: IExerciseRecord[], exerciseIndex: number, setIndex: number, weight: number, reps: number,
): IExerciseRecord[] {
  return exercises.map((exercise, index) => index === exerciseIndex ? {
    ...exercise,
    sets: exercise.sets.map((set, i) => i === setIndex ? { ...set, weight, reps, completed: true } : set),
  } : exercise);
}

export function skipWorkoutExercise(exercises: IExerciseRecord[], exerciseIndex: number): IExerciseRecord[] {
  return exercises.map((exercise, index) => index === exerciseIndex ? { ...exercise, skipped: true } : exercise);
}
